import { lazy } from "react";

export const ChangePasswordAsync = lazy(() => import("./ChangePassword"));
